import { c as core_cjs } from '../../common/core.cjs-6e75eed1.js';
import '../../common/index-d6ddf16f.js';



var ApolloClient = core_cjs.ApolloClient;
var InMemoryCache = core_cjs.InMemoryCache;
var createHttpLink = core_cjs.createHttpLink;
export { ApolloClient, InMemoryCache, createHttpLink };
